module.exports = __webpack_public_path__ + "media/Z33.fc524f46.mp3";